import { apiFetch } from "../auth/apiClient";

export const sosApi = {
  list: ({ status, signal } = {}) => {
    const qs = status ? `?status=${status}` : "";
    return apiFetch(`/api/sos${qs}`, { method: "GET", authRequired: true, signal });
  },

  raise: ({ lat, lng, signal } = {}) => {
    const body = {};
    if (lat !== undefined) body.lat = lat;
    if (lng !== undefined) body.lng = lng;
    return apiFetch("/api/sos", {
      method: "POST",
      authRequired: true,
      body: Object.keys(body).length ? body : undefined,
      signal,
    });
  },

  acknowledge: (id, { signal } = {}) =>
    apiFetch(`/api/sos/${id}/acknowledge`, { method: "POST", authRequired: true, signal }),

  resolve: (id, { note, signal } = {}) =>
    apiFetch(`/api/sos/${id}/resolve`, {
      method: "POST",
      authRequired: true,
      body: { note: note || "" },
      signal,
    }),

  cancel: (id, { signal } = {}) =>
    apiFetch(`/api/sos/${id}/cancel`, { method: "POST", authRequired: true, signal }),
};
